import { Controllers } from './external-controllers';

export default function controllerBinder(
    element: Document | HTMLElement,
    controllerBindings: Controllers
) {
    const elements = element.querySelectorAll('[data-controller]');
    [].forEach.call(elements, (ele: HTMLElement) => {
        if (ele) {
            const rawControllers = ele.getAttribute('data-controller');
            if (rawControllers) {
                const controllers = rawControllers.trim();
                if (controllers !== '') {
                    controllers.split(/\s+/).forEach((controllerName) => {
                        const controller = controllerBindings[controllerName];
                        if (controller) {
                            controller.callable(ele);
                        }
                    });
                }
            }
        }
    });
}
